/* GENERAL */
export const GET_DASHBOARD_INFO = "GET_DASHBOARD_INFO"
export const GET_DASHBOARD_INFO_SUCCESS = "GET_DASHBOARD_INFO_SUCCESS"
export const GET_DASHBOARD_INFO_FAIL = "GET_DASHBOARD_INFO_FAIL"

export const GET_DASHBOARD_OPTIONS = "GET_DASHBOARD_OPTIONS"
export const GET_DASHBOARD_OPTIONS_SUCCESS = "GET_DASHBOARD_OPTIONS_SUCCESS"
export const GET_DASHBOARD_OPTIONS_FAIL = "GET_DASHBOARD_OPTIONS_FAIL"

export const RESET_DASHBOARD_STATE = 'RESET_DASHBOARD_STATE';